module.exports = __webpack_public_path__ + "static/media/plano_de_fundo.12590dfb.png";